/** Content Engine HTTP helper (Firebase bearer token). */

export async function fetchWithAuth(
  url: string,
  idToken: string,
  body?: object
): Promise<Response> {
  return fetch(url, {
    method: body ? "POST" : "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: body ? JSON.stringify(body) : undefined,
  });
}
